export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/account-icon.svg?c65a55ed065c4c7aeff32a310e999062";